import { Result } from "antd";
import Loader from "Common/Loader";
import { Card, Modal, Button } from "react-bootstrap";
import CustomStore from "devextreme/data/custom_store";
import React, { useEffect, useState } from "react";
import DataGrid, {
    Column,
    Pager,
    Paging,
    Scrolling,
    SearchPanel,
    Summary,
    TotalItem,
} from "devextreme-react/cjs/data-grid";
import useHasPermission from "hooks/useHasPermission";
import { handleKeyDown } from "Common/Modal/ModalTriggerButton";
import moment from "moment";
import { GetInterStoreOderList } from "../services/InterStoreOrder.services";

const InterStoreOrderList = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const [showAddDeductionModal, setShowAddDeductionModal] = useState(false);
    const hasPermission = useHasPermission();

    const dataSource = (): any => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    const response = await GetInterStoreOderList(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };

    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    const formatDateToIST = (utcDateString: string): string => {
        if (!utcDateString) return "";

        const date = new Date(utcDateString + "Z");

        return new Intl.DateTimeFormat("en-IN", {
            timeZone: "Asia/Kolkata", // Force IST
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // 12h format with AM/PM
        })
            .format(date)
            .replace(",", ""); // remove comma for clean look
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">Inter Store Orders</h5>

                        </Card.Header>
                        <Card.Body>
                            {hasPermission("SalesPerson.Read") ? (
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    key={refreshKey}
                                    showBorders={true}
                                    columnAutoWidth={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}

                                >
                                    <Scrolling
                                        mode="standard"
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />

                                    <Paging defaultPageSize={10} />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />
                                    <Summary>
                                        <TotalItem />
                                    </Summary>

                                    <Column
                                        dataField="id"
                                        caption="Id"
                                        dataType="number"
                                        sortOrder="desc"
                                        visible={false}
                                        allowFiltering={false}
                                    />

                                    <Column
                                        cssClass='text-center'
                                        dataField="receiptNo"
                                        caption="Receipt No"
                                        dataType="string"
                                    />

                                    <Column
                                        cssClass='text-center'
                                        dataField="requestedStoreName"
                                        caption="Requested Store Name"
                                        dataType="number"
                                    />
                                    <Column
                                        cssClass='text-center'
                                        dataField="requestedStoreCode"
                                        caption="Requested Store Code"
                                        dataType="string"
                                        format="#,##0.00"
                                    />
                                    <Column
                                        cssClass='text-center'
                                        dataField="senderStoreName"
                                        caption="Sender Store Name"
                                        dataType="string"

                                    />
                                    <Column
                                        cssClass='text-center'
                                        dataField="senderStoreCode"
                                        caption="Sender Store Code"
                                        dataType="string"
                                    />

                                    <Column
                                        cssClass='text-center'
                                        dataField="customer"
                                        caption="Customer"
                                        dataType="string"
                                    />
                                    <Column
                                        dataField="createdOn"
                                        caption="Date"
                                        dataType="string"
                                        cssClass="text-center"
                                        allowSearch={false}
                                        calculateDisplayValue={(rowData) => formatDateToIST(rowData.createdOn)}

                                    />
                                    <Column
                                        cssClass='text-center'
                                        dataField="totalAmount"
                                        caption="Total Amount"
                                        dataType="number"
                                        format="#,##0.00"
                                    />
                                    <Column
                                        dataField="paidAmount"
                                        caption="Paid Amount"
                                        format="#,##0.00"
                                        dataType="number"
                                    />


                                    <Column
                                        dataField="gstAmount"
                                        caption="GST Amount"
                                        dataType="number"
                                        format="#,##0.00"
                                    />

                                    <Column
                                        dataField="status"
                                        caption="Status"
                                        dataType="string"
                                    />
                                    <Column
                                        dataField="karat"
                                        caption="Metal KT"
                                        dataType="string"
                                    />
                                    <Column
                                        dataField="styleNo"
                                        caption="Style No"
                                        dataType="string"
                                    />
                                    <Column
                                        dataField="size"
                                        caption="size"
                                        dataType="string"
                                        format="#,##0.00"
                                    />

                                </DataGrid>

                            ) : (
                                null

                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>

        </>
    );
};

export default InterStoreOrderList;
